{
  var swiper = new Swiper(".Banner_slider", {
    slidesPerView: 2.2,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    navigation:
      window.innerWidth < 576
        ? {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        : false,
    breakpoints: {
      150: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,
      },
      769: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 2.2,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".Value_stack_slider", {
    slidesPerView: 4,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    breakpoints: {
      150: {
        spaceBetween: 10,
        slidesPerView: 1.4,
      },
      576: {
        slidesPerView: 2.5,
      },
      769: {
        slidesPerView: 3.5,
      },
      1025: {
        slidesPerView: 4,
      },
    },
  });
}
{
  var swiper = new Swiper(".Hanging_Slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    loop: true,
    breakpoints: {
      150: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      576: {
        slidesPerView: 1.5,
        spaceBetween: 30,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".Brnds_col_slidr", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      150: {
        spaceBetween: 10,
      },
      576: {
        spaceBetween: 20,
      },
      1025: {
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".CusReview_slider", {
    slidesPerView: 3,
    spaceBetween: 30,
   navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      150: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".products_slider", {
    slidesPerView: 3,
    spaceBetween: 30,
      navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      150: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".About_slider", {
    slidesPerView: 3,
    spaceBetween: 30,
     navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      150: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
